import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router-dom';
import { Typography } from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';

import {
  BranchDetailsTabIcon,
  BranchDetailsTabIconDone,
  EmployeesTabIcon,
  EmployeesTabInprogress,
  EmployeesTabDone,
  BranchDetailsTabInprogress,
  SpecialtiesServicesTabIcon,
  SpecialtiesServicesTabInprogress,
  SpecialtiesServicesTabDone,
} from '../../../utils/Icons';
import { renderTextEllipsis, setPageMainTitle } from '../../../utils/Helpers';
import { ROUTE_PATHS } from '../../../utils/RoutesPaths';
import Stepper from '../../../components/Stepper';
import Button from '../../../components/Button';
import Modal from '../../../components/Modal';
import messages from '../../../assets/locale/messages';
import AddBranchDetails from './AddBranchDetails';
import AddServicesDetails from './AddServicesDetails';
import AddEmployeesDetails from './AddEmployeesDetails';
import {getBranchRequest, addBranchResponse} from "../../../store/Branches/actions" 

const AddBranch = (props) => {
  const dispatch = useDispatch();
  const urlParams = new URLSearchParams(window.location.search);
  const currentTab = +urlParams.get('CurrentTab') || 1;
  const history = useHistory();
  const { providerid, branchid } = useParams();
  const lang = useSelector((state) => state.locale.lang);
  const { pagesTitles, branches, shared } = messages[lang];
  // const createdBranch = useSelector((state) => state.branches.addedBranch);
  const branchDataById = useSelector((state) => state.branches.branchDetails);
  const [tabIndex, setTabIndex] = useState(currentTab-1);
  const [btnClicked, setBtnClicked] = useState(null);
  const [renderList, setRenderList] = useState(false);
  const [renderSubTitle, setRenderSubTitle] = useState(null);
  const [pageTitle, setPageTitle] = useState('addProviderBranch');
  const [renderServiceTitle, setRenderServiceTitle] = useState(null);
  const [showLeaveWarningModal, setShowLeaveWarningModal] = useState(false);
  const [hideAddBtn, setHideAddBtn] = useState(false);
  const branchCreatedId = history.location?.state?.branchCreatedId;

  const stepperItems = [
    {
      label: branches.addBranch.firstTab,
      icon: [<BranchDetailsTabIcon />, <BranchDetailsTabInprogress />, <BranchDetailsTabIconDone />],
    },
    {
      label: branches.addBranch.secondTab,
      icon: [<SpecialtiesServicesTabIcon />, <SpecialtiesServicesTabInprogress />, <SpecialtiesServicesTabDone />],
    },
    {
      label: branches.addBranch.thirdTab,
      icon: [<EmployeesTabIcon />, <EmployeesTabInprogress />, <EmployeesTabDone />],
    },
  ];

  useEffect(() => {
    if (!branchid && !branchCreatedId) return;
    dispatch(getBranchRequest(branchid || branchCreatedId));
  }, [branchid, branchCreatedId]);

  useEffect(() => {
    setTabIndex(currentTab-1);
  }, [urlParams.get('CurrentTab')]);

  useEffect(() => {
    if(branchDataById && Object.keys(branchDataById).length) dispatch(addBranchResponse(branchDataById));
  }, [branchDataById]);

  
  
  useEffect(() => {
    if (props?.location?.state?.setPageTitleEn !== undefined || props?.location?.state?.setPageTitleAr !== undefined) {
      setPageTitle(lang === 'en' ? props?.location?.state?.setPageTitleEn : props?.location?.state?.setPageTitleAr);
    }
    setBtnClicked(null);
  }, [lang]);

  useEffect(() => {
    setPageMainTitle('branchesManagement'); 
  }, []);

  useEffect(() => {
    switch (tabIndex) {
      case 0:
        setBtnClicked(null);
        setRenderSubTitle(null);
        setRenderServiceTitle(null);
        break;
      case 1:
        setPageTitle(
          props?.location?.state?.setPageTitle !== undefined
            ? props?.location?.state?.setPageTitle
            : 'addProviderBranchSpecialties'
        );
        setBtnClicked(null);
        setRenderSubTitle(null);
        setRenderServiceTitle(null);
        setRenderList(false);
        break;
      case 2:
        setPageTitle(
          props?.location?.state?.setPageTitle !== undefined
            ? props?.location?.state?.setPageTitle
            : 'addProviderBranchEmployees'
        );
        setBtnClicked(null);
        setRenderSubTitle(null);
        setRenderServiceTitle(null);
        setRenderList(true);
        break;
      default:
        break;
    }
  }, [tabIndex]);

  const onSubTitleChange = (title) => {
    setRenderList(false);
    setRenderSubTitle(title);
  };

  const onServiceTitleChange = (title) => {
    setRenderList(false);
    setRenderServiceTitle(title);
  };

  const refreshCurrentTab = () => {
    // setTabIndex(tabIndex === 0 ? 1 : tabIndex === 1 ? 0 : tabIndex === 2 ? 1 : tabIndex);
    // setTimeout(() => {
    //   setTabIndex(tabIndex === 0 ? 1 : tabIndex === 1 ? 2 : tabIndex === 2 ? tabIndex : 1);
    // }, 200);
  };

  const handleSelectStep = (step, state) => {
    history.push({ search: `?CurrentTab=${step+1}`, state: state || props.location.state });
  };

  const handleCloseShowLeaveWarningModal = () => {
    setShowLeaveWarningModal(false);
  };

  const handleConfirmShowLeaveWarning = () => {
    history.push(ROUTE_PATHS.viewServiceProvider.replace(':id', providerid));
    setShowLeaveWarningModal(false);
  };

  const removeMainAddBtn = (value) => {
    setHideAddBtn(value);
  };

  return (
    <>
      <div className="add-branch-page">
        <div className="header d-flex mb-4 align-items-center  flex-lg-nowrap flex-wrap gap-lg-0 gap-4">
          <Typography variant="h4" sx={{ flexGrow: 1 }} className={`page-title`}>
            <div className="d-flex fsize-24 flex-wrap gap-1">
              <div
                className={`${renderSubTitle !== null && 'pointer'}`}
                onClick={() => {
                  setBtnClicked('list');
                  setRenderSubTitle(null);
                  setRenderServiceTitle(null);
                  setRenderSubTitle(null);
                  setRenderServiceTitle(null);
                  setRenderList(true);
                }}>
                {renderTextEllipsis(props?.location?.state?.setPageTitle !== undefined && props?.location?.state?.noTranslationForTitle
                  ? pageTitle
                  : pagesTitles[pageTitle])}
              </div>
              {renderSubTitle !== null && (
                <div
                  className="pointer"
                  onClick={() => {
                    setBtnClicked('listSpecialties');
                    onServiceTitleChange(null);
                  }}>
                  / {branches.addBranch.labels[renderSubTitle]}
                </div>
              )}
              {renderServiceTitle !== null && renderSubTitle !== null && <div> / {renderTextEllipsis(renderServiceTitle)}</div>}
            </div>
          </Typography>
          <div>
            {tabIndex === 2 && (renderSubTitle == null || renderSubTitle === 'addEmployee') && !hideAddBtn && (
              <Button
                onClick={() => {
                  setBtnClicked('');
                  setBtnClicked('add');
                }}
                type="button"
                block
                label={
                  <span className="d-flex align-items-center">
                    <Add fontSize="large" />
                    <span className="ps-1 ">{branches.addBranch.labels.addEmployee}</span>
                  </span>
                }
                labelClass="fsize-16 text-white py-1"
              />
            )}
            {tabIndex === 2 && renderSubTitle === 'employessDetails' && (
              <div className="d-flex gap-2">
                <Button
                  onClick={() => {
                    setBtnClicked('delete');
                  }}
                  color="info"
                  outlined
                  label={
                    <span className="d-flex align-items-center">
                      <Delete fontSize="small" />
                      <span>{shared.delete}</span>
                    </span>
                  }
                  className="btn-secondary"
                  labelClass="fsize-14 btn-info-generate-password"
                />
                <Button
                  onClick={() => {
                    setBtnClicked('edit');
                  }}
                  type="button"
                  label={
                    <span className="d-flex align-items-center">
                      <Edit fontSize="small" />
                      <span className="ps-1">{shared.edit}</span>
                    </span>
                  }
                  labelClass="fsize-16 text-white py-1"
                />
              </div>
            )}
            {tabIndex === 1 && !hideAddBtn && (
              <Button
                onClick={() => {
                  handleSelectStep(1);
                  setRenderList(true);
                  setBtnClicked('listSpecialties');
                }}
                type="button"
                block
                label={
                  <span className="d-flex align-items-center flex-wrap justify-content-center">
                    <Add fontSize="large" />
                    <span className="ps-1 ">{branches.addBranch.labels.addSepicialtiesAndServices}</span>
                  </span>
                }
                labelClass="fsize-16 text-white py-1"
                className="w-max-content"
              />
            )}
          </div>
        </div>
        <div className="add-branch-stepper">
          <Stepper
            steps={stepperItems}
            handleSelectStep={handleSelectStep}
            currentStep={tabIndex}
            preventGoingBack={false}
            // haveBranchId={createdBranch?.id ? true : false}
            // haveServices={createdBranch?.specialties?.length > 0 ? true : false}
            haveBranchId={!!branchDataById?.id }
            haveServices={!!branchDataById?.specialties?.length}
          />
        </div>
        <div className="page-container mt-5 bg-white rounded-4">
          {tabIndex === 0 && (
            <AddBranchDetails
              setShowLeaveWarningModal={setShowLeaveWarningModal}
              parentProps={props}
              proceedToNextStep={(state) => handleSelectStep(1,state)}
            />
          )}
        </div>
        <div className="page-container mt-5 bg-white rounded-4">
          {tabIndex === 1 && (
            <AddServicesDetails
              changeSubTitle={onSubTitleChange}
              changeServiceTitle={onServiceTitleChange}
              renderList={renderList}
              btnClicked={btnClicked}
              proceedToNextStep={() => handleSelectStep(2)}
              ressetBtnClicked={() => setBtnClicked(null)}
              backToPrevStep={() => handleSelectStep(0)}
              parentProps={props}
              removeMainAddBtn={removeMainAddBtn}
              setBtnClicked={setBtnClicked}
            />
          )}
        </div>
        <div className="page-container mt-5">
          {tabIndex === 2 && (
            <AddEmployeesDetails
              btnClicked={btnClicked}
              changeSubTitle={onSubTitleChange}
              renderList={renderList}
              refreshCurrentTab={refreshCurrentTab}
              backToPrevStep={() => handleSelectStep(1)}
              parentProps={props}
              removeMainAddBtn={removeMainAddBtn}
              ressetBtnClicked={() => setBtnClicked(null)}
            />
          )}
        </div>
      </div>
      <Modal
        open={showLeaveWarningModal}
        handleClose={handleCloseShowLeaveWarningModal}
        title={branches.addBranch.labels.confirmCancel}
        contentClass="mb-5 pb-2 text-primary"
        content={<span>{branches.addBranch.labels.confirmCancelMessage}</span>}
        confirmBtnTxt={shared.confirm}
        maxWidth="xs"
        cancelBtnTxt={shared.cancel}
        isContentText={false}
        handleConfirm={handleConfirmShowLeaveWarning}
        handleCancel={handleCloseShowLeaveWarningModal}
        modalClass="delete-services-modal"
        actionsClass="container px-4"
        confirmBtnClass="btn-secondary fsize-14 text-white py-2 "
        cancelBtnClass="fsize-14 py-2"
      />
    </>
  );
};

export default AddBranch;
